;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function ClockWithMan() {
  return (
    <svg width="159" height="151" viewBox="0 0 159 151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M62.6387 150.885V134.379C62.6387 123.474 42.7322 117.872 32.1424 117.872C21.5527 117.872 1.64612 123.474 1.64612 134.379V150.885"
        stroke="#455A63"
        strokeWidth="3"
      />
      <path
        d="M32.1424 107.973C39.3083 108.283 45.3768 102.873 45.6951 95.8924C45.717 95.5183 45.717 95.1441 45.6951 94.7699V88.1738C45.6951 80.8828 39.6375 74.9709 32.1424 74.9602C24.6582 74.9602 18.5897 80.8614 18.5787 88.1631V94.7806C18.2605 101.762 23.8132 107.673 30.9791 107.984C31.3632 108.005 31.7473 108.005 32.1314 107.984L32.1424 107.973Z"
        stroke="#455A63"
        strokeWidth="3"
      />
      <path d="M113.459 51.8579L82.9622 78.2637L69.4095 58.454" stroke="#FFB400" strokeWidth="3" />
      <path d="M82.0295 22.2769V34.2503" stroke="#455A63" strokeWidth="3" />
      <path d="M136.098 74.9495H123.807" stroke="#455A63" strokeWidth="3" />
      <path d="M82.0295 127.622V115.659" stroke="#455A63" strokeWidth="3" />
      <path
        d="M22.8147 65.0607C28.4553 32.7323 59.9282 10.9769 93.1131 16.4612C126.298 21.9562 148.63 52.6169 143 84.9453C137.371 117.242 105.963 138.986 72.8005 133.555"
        stroke="#455A63"
        strokeWidth="3"
      />
      <path
        d="M8.41699 74.9602C8.46089 34.9025 41.8323 2.44581 82.9623 2.48857C124.092 2.53133 157.398 35.0415 157.354 75.1099C157.31 115.178 123.939 147.624 82.8087 147.582C79.4616 147.582 76.1256 147.357 72.8005 146.919"
        stroke="#455A63"
        strokeWidth="3"
      />
    </svg>
  );
}
